import { Typography } from '@iheartjane/reefer';
import { useMemo } from 'react';

import { FeelingIconMap } from '@jane/bloom/components/iconMaps/feelingIconMap';
import { cappedCount } from '@jane/bloom/utils/strings/cappedCount';
import type { FeelingCard } from '@jane/bloom/viewModels/productReviews';

import styles from './topFeelings.module.css';

interface TopFeelingsProps {
  feelings: FeelingCard[];
}

export function TopFeelings({ feelings }: TopFeelingsProps) {
  const total = useMemo(
    () => feelings.reduce((prev, curr) => prev + curr.count, 0),
    [feelings]
  );

  if (feelings.length === 0) {
    return null;
  }

  return (
    <div className={styles['topFeelingsSection']}>
      <Typography mb={8} mt={24} variant="body-semibold" color="text-main">
        Top Feelings
      </Typography>
      <div className={styles['topFeelingsContainer']}>
        {feelings.map(({ count, value }) => {
          const widthPercentage = (count / total) * 100;

          return (
            <div
              className={styles['topFeelingsBox']}
              key={value}
              style={{ width: `${widthPercentage}%` }}
            >
              {FeelingIconMap[value]}
              <Typography textAlign="center" color="text-main">
                {value} ({cappedCount(count)})
              </Typography>
            </div>
          );
        })}
      </div>
    </div>
  );
}
